import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';
import { menuAccessGuard } from '../../core/guards/menu-access.guard';
import { pendingChangesGuard } from '../../core/guards/pending-changes.guard';

function withAuthGuard(routes: Routes): Routes {
    return routes.map((route) => ({
        ...route,
        canActivate: route.canActivate
            ? [authGuard, menuAccessGuard, ...route.canActivate]
            : [authGuard, menuAccessGuard],
    }));
}

export const userRoutes: Routes = withAuthGuard([
    {
        title: 'Transmaritime - Inicio',
        path: 'home',
        loadComponent: () =>
            import('../../shared/features/home/pages/home.component').then(
                (m) => m.HomeComponent
            ),
    },
    {
        title: 'Transmaritime - Servicios',
        path: 'service-operations',
        loadComponent: () =>
            import('../user/service-operations/pages/service-operations').then((m) => m.ServiceOperations),
    },
    {
        title: 'Transmaritime - Pago servicios',
        path: 'payment-wizard',
        loadComponent: () =>
            import('../user/payment-wizard/pages/payment-wizard').then(
                (m) => m.PaymentWizard,
            ),
        canDeactivate: [pendingChangesGuard],
    },
]);
